import { NotificationDto } from "../api/notification/notification";

export type RealtimeNotification = NotificationDto & { userId: string };

export interface NotificationWebSocketErrorPayload {
  code: string;
  message: string;
}

export type NotificationWebSocketMessage = RealtimeNotification | NotificationWebSocketErrorPayload;

export const USER_DEVICE_REGISTRATION_REQUIRED_CLOSE_CODE = 4412;

export function isRealtimeNotification(message: unknown): message is RealtimeNotification {
  return (
    isRecord(message) &&
    typeof message["id"] === "string" &&
    typeof message["userId"] === "string" &&
    typeof message["category"] === "string" &&
    typeof message["type"] === "string" &&
    typeof message["createdAt"] === "number" &&
    typeof message["readStatus"] === "boolean" &&
    "severity" in message &&
    isRecord(message["data"])
  );
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
